// Copyright © 2021 Move Closer
import { defineComponent } from '@vue/composition-api';
import { linkContentProps } from './LinkContent.hooks';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const LinkContent = defineComponent({
    name: 'LinkContent',
    props: linkContentProps,
    template: `
    <span v-if="$slots.default" class="link-content">
        <slot/>
    </span>
    <span v-else-if="label && label.length" class="link-content">
        {{ label }}
    </span>
    <span v-else />
  `
});
